import { FormattedMessage as FM } from "react-intl";

import PreviewCard from "./PreviewCard";
import PreviewCart from "./PreviewCart";
import PreviewHeader from "./PreviewHeader";
import PreviewHero from "./PreviewHero";
import { getSiteColors } from "../helpers/hotelDefaults";
import { PREVIEW_CARDS } from "../constants";

function SitePreview({ data }) {
  const colors = getSiteColors(data);
  const title = data.title;
  const heroTitle = data.main_title || title;
  const heroImage = data.main_background || data.banner;

  return (
    <div className="rounded-lg border border-neutral-200 bg-white p-3 shadow-sm">
      <p className="text-sm font-semibold text-neutral-700">
        <FM id="melhous.dash.preview.title" />
      </p>
      <p className="mb-3 text-xs text-neutral-500">
        <FM id="melhous.dash.preview.help" />
      </p>
      <div className="mx-auto w-full max-w-64 rounded-[1.75rem] bg-neutral-800 p-1.5 shadow-md">
        <div
          className="flex flex-col overflow-hidden rounded-3xl"
          style={{
            backgroundColor: colors.surface_color,
            color: colors.text_color,
          }}
        >
          <PreviewHeader logo={data.logo} title={title} colors={colors} />
          <PreviewHero image={heroImage} title={heroTitle} colors={colors} />
          <div className="space-y-2 p-3">
            <p className="text-xs font-semibold">
              <FM id="melhous.dash.preview.section" />
            </p>
            {PREVIEW_CARDS.map((index) => (
              <PreviewCard key={index} colors={colors} index={index} />
            ))}
            <PreviewCart colors={colors} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SitePreview;
